const map = {
	"./trkType-container.svg": 2094,
	"./trkType-hyva.svg": 6679,
	"./trkType-lcv.svg": 7136,
	"./trkType-open body truck.svg": 8226,
	"./trkType-tanker.svg": 3112,
	"./trkType-trailer.svg": 4562,
	"./trkType-truck.svg": 3726
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2401;